import { getLocalStorage } from "./localStorageservice";

const Auth = {
    isAuthenticated(): any {
        return getLocalStorage("user");
    },
};

export default Auth;
